import { render } from "./RolesDashboardComponent.vue?vue&type=template&id=b208f458"
import script from "./RolesDashboardComponent.vue?vue&type=script&lang=js"
export * from "./RolesDashboardComponent.vue?vue&type=script&lang=js"
script.render = render

export default script